import React, {useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { setScheduleStep } from "../../../Store/Slice/scheduleSlice";
import Button from "../../../UI/Button";
import Pricing from "./Pricing";
import Cards from "./Cards";
import Footer from "./Footer";

export default function SchedulePayment() {
  const dispatch = useDispatch();
  const [type, setType] = useState(true);
  const [totalPriceValue, setTotalPriceValue] = useState(0)
  const scheduleStep = useSelector((state) => state.rootReducer.scheduleSlice.schedule_step);
  const payment_method_id = useSelector((state) => state.rootReducer.scheduleSlice.sendData?.payment_method_id);
  const isButtonDisabled = payment_method_id == null && type;

  const handleSubmit = (step) => {
    dispatch(setScheduleStep(step));
  };
  return (
    <div className={`schedule__block ${scheduleStep === 4 ? "active" : ""}`}>
      <h2 className="schedule__title">
        <div>4. Payment method</div>
        {scheduleStep > 4 && <span onClick={() => handleSubmit(4)}>Change</span>}
      </h2>
      <div className="schedule__hr"></div>
      <div className="schedule__content">
        <div className="payment__content">
          <Cards type={type} setType={setType}/>
          <Pricing setTotalPriceValue={setTotalPriceValue}/>
        </div>
        <div className="lineitems__footer">
          <Button
            onClick={() => handleSubmit(5)}
            disabled={isButtonDisabled}
            text="Continue"
          />
        </div>
      </div>
      {scheduleStep > 4 && totalPriceValue > 0 && (
        <Footer type={type} totalPriceValue={totalPriceValue.toFixed(2)} />
      )}
    </div>
  );
}
